module.exports = __webpack_public_path__ + "img/initial2020.df8cae43.png";